import { EndpointSetting } from "@/lib/redux/type";
import { ProductState } from "../type";

export const callbackGetCategoryProducts: EndpointSetting['caller'] = (
  state: ProductState,
  action: any,
  endpointName: string
) => {
  state.product_list.loading = false
  state.product_list.called = true
  state.product_list.success = true
  state.product_list.error = null
  state.product_list.filter = {
    page: action.payload.page,
    page_size: action.payload.page_size,
    total_length: action.payload.total_length
  }

  state.product_list.data = action.payload.results
}